'use client';

import { useCallback } from 'react';
import { shared } from '../config';
import { CUSTOMER_ENDPOINT } from '../customer/constants';

export const useMigratedCustomer = storedSessionUser => {
  const isShopifyUser = storedSessionUser?.user?.shopify_user;
  const fetchCustomer = useCallback(async () => {
    const response = await fetch(
      `${shared.API_HTTP_SCHEME}://${shared.API_BASE_URL}${CUSTOMER_ENDPOINT}${storedSessionUser?.id}/`,
      {
        headers: {
          Authorization: `Bearer ${storedSessionUser?.access_token}`,
          // the BE will reject any calls without a valid x-ollie-user-id property
          ...(isShopifyUser && {
            'x-ollie-user-id': `${storedSessionUser?.shopify_id}`,
          }),
        },
      },
    );
    const customerJson = await response.json();
    return customerJson;
  }, [storedSessionUser, isShopifyUser]);

  return { fetchCustomer };
};
